interface IEventData {
    func: Function;
    id: number;
    weight: number;
}

interface IEvent {
    [eventName: string]: IEventData[];
}

export class EventEmitter {
    private handle: IEvent = {};
    private id = 1;
    private idToEventMap = new Map<number, string>();

    on(eventName: string, cb: Function, weight = 0) {
        if (!this.handle[eventName]) {
            this.handle[eventName] = [];
        }
        const data: IEventData = { func: cb, id: this.id++, weight };
        this.handle[eventName].push(data);
        this.handle[eventName].sort((a, b) => b.weight - a.weight);
        this.idToEventMap.set(data.id, eventName);
        // console.log('event => ', eventName, this.handle[eventName].length);
        return data.id;
    }

    onUnique(eventName: string, cb: Function) {
        const data: IEventData = { func: cb, id: this.id++, weight: 0 };
        const eventsList = this.handle[eventName];
        if (eventsList) {
            for (let i = 0; i < eventsList.length; i++) {
                const element = eventsList[i];
                this.idToEventMap.delete(element.id);
            }
        }
        this.handle[eventName] = [data];
        this.idToEventMap.set(data.id, eventName);
        return data.id;
    }

    off(): void; // 清除所有事件
    off(id: number): void; // 通过 id 清除
    off(eventName: string): void; // 清除指定事件的所有监听器
    off(eventName: string, cb: Function): void; // 清除指定事件的特定回调
    off(eventName?: string | number, cb?: Function) {
        // 如果没有参数，清除所有事件
        if (arguments.length === 0) {
            this.handle = {};
            this.idToEventMap.clear();
            return;
        }

        // 如果第一个参数是数字（id），直接通过 id 清除
        if (typeof eventName === 'number') {
            const event = this.idToEventMap.get(eventName);
            if (!event) return;

            const list = this.handle[event];
            if (!list) return;

            for (let i = 0; i < list.length; i++) {
                if (list[i].id === eventName) {
                    list.splice(i, 1);
                    this.idToEventMap.delete(eventName);
                    if (list.length === 0) {
                        delete this.handle[event];
                    }
                    break;
                }
            }
            return;
        }

        // 处理 eventName 为字符串的情况
        if (typeof eventName === 'string') {
            const list = this.handle[eventName];
            if (!list || list.length <= 0) return;

            // 如果没有第二个参数，清除该事件的所有监听器
            if (!cb) {
                // 清除所有相关的 id 映射
                list.forEach((item) => this.idToEventMap.delete(item.id));
                delete this.handle[eventName];
                return;
            }

            // 清除特定的回调函数
            for (let i = 0; i < list.length; i++) {
                if (list[i].func === cb) {
                    this.idToEventMap.delete(list[i].id);
                    list.splice(i, 1);
                    break;
                }
            }

            // 如果该事件的监听器列表为空，则删除该事件
            if (list.length === 0) {
                delete this.handle[eventName];
            }
        }
    }

    emit(eventName: string, ...args: any) {
        this.dispatchEvent(eventName, ...args);
    }

    dispatchEvent(eventName: string, ...args: any) {
        const list = this.handle[eventName];

        if (!list || list.length <= 0) {
            return;
        }

        for (let i = 0; i < list.length; i++) {
            const event = list[i];
            const stop = event.func.apply(this, args);
            if (stop === true) {
                break;
            }
        }
    }
}
